import * as React from 'react';
import { connect } from 'react-redux';
import { MainState } from "../../../../Core/reducers";
import { CheckForEventsAsyncAction } from './ReprocessCoughSessionModalActions';
import LoadingWithMessage from '../../../../misc/components/LoadingWithMessage';
import FailureWithMessage from '../../../../misc/components/FailureWithMessage';
import SuccessWithMessage from '../../../../misc/components/SuccessWithMessage';
import { DeviceMessage } from '../../../../device-return/components/device-message';
import { CoughSession } from 'webportalclient';
import { useWebPortalLegacyClient } from '../../../../misc/api/WebPortalTokenClient';

interface ReprocessCoughSessionConfirmationStateProps {  
    dispatch?: any;
    analysisSetsWithEvents: string[];
    isFetching: boolean;
    error: string;
}

interface ReprocessCoughSessionConfirmationOwnProps {
    coughSession: CoughSession;
    onCancel: () => void;
    nextText: string;
    backText: string;
    onNext: () => void;
}

export interface ReprocessCoughSessionConfirmationProps extends ReprocessCoughSessionConfirmationStateProps, ReprocessCoughSessionConfirmationOwnProps { };

export const ReprocessCoughSessionConfirmation = (props: ReprocessCoughSessionConfirmationProps) => {
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        checkForEvents();
    }, [props.coughSession]);

    const checkForEvents = () => {
        props.coughSession && props.dispatch(CheckForEventsAsyncAction.create(props.coughSession.id, legacyClient));
    }

    const renderLoading = () => {
        return props.isFetching ? <LoadingWithMessage message="Checking For Events."></LoadingWithMessage> : "";
    }

    const anyAnalysisSetsWithEventsExist = () => {
        return props.analysisSetsWithEvents && !!props.analysisSetsWithEvents.length;
    }

    const renderAnalysisSets = () => {
        if (props.isFetching) {
            return null;
        }

        return anyAnalysisSetsWithEventsExist() ? <FailureWithMessage message={"Events Exist In The Following Analysis Sets: (" + props.analysisSetsWithEvents.join(" , ") + ")"}></FailureWithMessage> : <SuccessWithMessage message="No Events Exist In Related Analysis Sets."></SuccessWithMessage>;
    }

    const getWarningMessages = () => {
        return [
            "This will reprocess the audio files for cough session " + props.coughSession.name + " and subject " + props.coughSession.visit.subject.number + ". This will remove any analysis sets (excluding Subject) related to this cough session. These analysis sets cannot be recovered. Ensure all events are removed from the all analysis sets (excluding Subject) before continuing."
        ]
    }

    return <>
        <div className='modal-body'>
            <DeviceMessage messages={getWarningMessages()} color="warning">
            </DeviceMessage>

            {renderLoading()}

            {renderAnalysisSets()}
        </div>

        <div className='modal-footer'>
            <button disabled={props.isFetching || !!props.error || anyAnalysisSetsWithEventsExist()} className='btn btn-primary' onClick={() => props.onNext()}>
                {props.nextText}
            </button>
            <button className='btn btn-primary btn-outline' onClick={() => props.onCancel()}>{props.backText}</button>
        </div>
    </>
}


function mapStateToProps(state: MainState, ownProps: ReprocessCoughSessionConfirmationOwnProps): ReprocessCoughSessionConfirmationProps {
    return {
        coughSession: ownProps.coughSession,
        isFetching: state.coughSessionsList.reprocessCoughSessionModal.isFetching,
        analysisSetsWithEvents: state.coughSessionsList.reprocessCoughSessionModal.analysisSetsWithEvents,
        error: state.coughSessionsList.reprocessCoughSessionModal.error,
        backText: ownProps.backText,
        nextText: ownProps.nextText,
        onCancel: ownProps.onCancel,
        onNext: ownProps.onNext
    };
}

export default connect(mapStateToProps)(ReprocessCoughSessionConfirmation);
